import { EditFilled } from '@ant-design/icons';
import { SwitchInput } from '@framework/form/inputs/SwitchInput.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { Space, Tooltip } from 'antd';
import { useWatch } from 'react-hook-form';
import styled from 'styled-components';
import {
  CiComputedNumberGear,
  CiComputedStringGear,
} from '../../../../../../ui/icons-custom/IconsCustom.tsx';
import { ComputeExpressionInput } from '../../../../../expressions/compute/input/ComputeExpressionInput.tsx';
import { Datatype } from '../../../../../expressions/datatype/Datatype.ts';
import { type IPaymentRowWidget } from '../IPaymentRowWidget.ts';

const Container = styled.div`
  border: 1px solid ${props => props.theme.colorBorder};
  border-radius: ${props => props.theme.borderRadius}px;
  padding: 8px;
  width: 100%;
  h3 {
    font-weight: bolder;
  }
`;

export interface IPaymentRowFieldConfigProps {
  name: keyof IPaymentRowWidget;
  title: string;
  widgetId: string;
  datatype: Datatype;
}

/**
 * Componente per la configurazione dei singoli campi di una voce di costo
 * (descrizione, quantità, totale, ...)
 */
export function PaymentRowFieldConfig(props: IPaymentRowFieldConfigProps) {
  const { name, title, widgetId, datatype } = props;

  const editableValue = useWatch({ name: `${name}.editable` });

  return (
    <Container>
      <Space>
        <Tooltip title={editableValue ? 'Modificabile' : 'Calcolato'}>
          <FormItem
            name={`${name}.editable`}
            style={{
              padding: '0px',
              margin: '0px',
              paddingBottom: '0.8em',
            }}
          >
            <SwitchInput
              name={`${name}.editable`}
              checkedChildren={<EditFilled />}
              unCheckedChildren={
                datatype === Datatype.String ? (
                  <CiComputedStringGear />
                ) : (
                  <CiComputedNumberGear />
                )
              }
              size="small"
            />
          </FormItem>
        </Tooltip>

        <h3>{title}</h3>
      </Space>

      {/* Se non è modificabile, mostriamo un campo calcolato */}
      {!editableValue && (
        <FormItem
          name={[`${name}.expression.raw`, `${name}.expression.value`]}
          label="Espressione"
        >
          <ComputeExpressionInput
            name={`${name}.expression`}
            widgetId={widgetId}
            includeSelf={false}
            noFunctions={datatype === Datatype.String}
          />
        </FormItem>
      )}
    </Container>
  );
}
